import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

const HelmetWrapper = ({ title, children }) => {
  return (
    <HelmetProvider>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {children}
    </HelmetProvider>
  );
};

export default HelmetWrapper;
